<!-- <ng-http-loader></ng-http-loader> -->
<ng-http-loader [spinner]="spinkit.skThreeBounce"></ng-http-loader>

<router-outlet>
</router-outlet>


<!-- skChasingDots: 'sk-chasing-dots',
    skCubeGrid: 'sk-cube-grid',
    skDoubleBounce: 'sk-double-bounce',
    skRotatingPlane: 'sk-rotationg-plane',
    skSpinnerPulse: 'sk-spinner-pulse',
    skThreeBounce: 'sk-three-bounce',
    skWanderingCubes: 'sk-wandering-cubes',
    skWave: 'sk-wave' -->